import React, { useReducer, useEffect } from 'react';
import TextFeild from '@material-ui/core/TextField';
import FullCard from '../../../../components/Card/FullCard';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import API from '../../../../api/axios';
import Skeleton from '@material-ui/lab/Skeleton';
import TextField from '@material-ui/core/TextField';
import toEN from '../../../../fns/toEn';
import useTitle from 'hooks/useTitle';

function GeneralParams(props) {
  useTitle('پارامتر های کلی');
  const initialState = {
    generalParams: {
      bidDuration: '',
      bidDriverSelectDuration: '',
      minToleranceOrderPercentage: '',
      maxToleranceOrderPercentage: '',
      driverToOriginMaxDistance: '',
      freightToOriginMaxDistance: '',
      minToleranceDriversOrderPercentage: '15',
      maxToleranceDriversOrderPercentage: '15',
    },
    isLoaded: false,
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  function reducer(state, action) {
    const { type, payload } = action;
    switch (type) {
      case 'LOAD_GENERAL_PARAMS':
        const {
          driverToOriginMaxDistance,
          freightToOriginMaxDistance,
          bidDriverSelectDuration,
          toleranceOrderPercentage,
          toleranceDriversOrderPercentage,
          bidDuration,
        } = payload;
        const minToleranceOrderPercentage = Math.min(
          ...toleranceOrderPercentage
        );
        const maxToleranceOrderPercentage = Math.max(
          ...toleranceOrderPercentage
        );
        const minToleranceDriversOrderPercentage = Math.min(
          ...toleranceDriversOrderPercentage
        );
        const maxToleranceDriversOrderPercentage = Math.max(
          ...toleranceDriversOrderPercentage
        );
        return {
          ...state,
          generalParams: {
            bidDuration,
            driverToOriginMaxDistance,
            freightToOriginMaxDistance,
            bidDriverSelectDuration,
            minToleranceOrderPercentage,
            maxToleranceOrderPercentage,
            minToleranceDriversOrderPercentage,
            maxToleranceDriversOrderPercentage,
          },
          isLoaded: true,
        };
      case 'CHANGE_FIELD':
        const { name, value } = payload;
        return {
          ...state,
          generalParams: { ...state.generalParams, [name]: value },
        };
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      default:
        return { ...state };
    }
  }
  // Function to load general params from db
  const loadData = async () => {
    try {
      const response = await API.get(`/api/v1/admin/generalparam`);
      await dispatch({ type: 'LOAD_GENERAL_PARAMS', payload: response.data });
    } catch (err) {
      console.error(err);
    }
  };
  // function to handle form fields change
  const handleFieldsChange = ({ target }) => {
    let { name, value } = target;
    value = toEN(value);
    dispatch({ type: 'CHANGE_FIELD', payload: { name, value } });
  };
  const handleSaveForm = async () => {
    const errors = [];
    const {
      bidDuration,
      driverToOriginMaxDistance,
      freightToOriginMaxDistance,
      bidDriverSelectDuration,
      minToleranceOrderPercentage,
      maxToleranceOrderPercentage,
      minToleranceDriversOrderPercentage,
      maxToleranceDriversOrderPercentage,
    } = state.generalParams;

    !driverToOriginMaxDistance && errors.push('حداکثر مسافت راننده از محل بار');
    !freightToOriginMaxDistance &&
      errors.push('حداکثر مسافت باربری از محل بار');
    !bidDriverSelectDuration &&
      errors.push('مدت زمان انتظار برای تایید مناقصه');
    !bidDuration && errors.push('مدت زمان انتظار یک سفارش');
    !minToleranceOrderPercentage &&
      errors.push('حداقل درصد پیشنهاد مناقصه برای صاحب بار');
    !maxToleranceOrderPercentage &&
      errors.push('حداکثر درصد پیشنهاد مناقصه برای صاحب بار');
    !minToleranceDriversOrderPercentage &&
      errors.push('حداقل پیشنهاد مناقصه برای راننده');
    !maxToleranceDriversOrderPercentage &&
      errors.push('حداکثر پیشنهاد مناقصه برای راننده');

    if (errors.length) {
      console.error(errors);
      props.showMessage(
        2,
        'tr',
        'بروز خطا',
        <div>
          لطفا فیلدهای زیر را پر نمایید:
          {errors.map((er, index) => (
            <li key={index}>{er}</li>
          ))}
        </div>
      );
      return;
    }
    dispatch({ type: 'LOADING' });
    const dataToSend = {
      bidDuration,
      driverToOriginMaxDistance,
      freightToOriginMaxDistance,
      bidDriverSelectDuration,
      toleranceOrderPercentage: [
        minToleranceOrderPercentage,
        maxToleranceOrderPercentage,
      ],
      toleranceDriversOrderPercentage: [
        minToleranceDriversOrderPercentage,
        maxToleranceDriversOrderPercentage,
      ],
    };

    try {
      const response = await API.put(`/api/v1/admin/generalparam`, dataToSend);
      props.showMessage(1, 'tr', 'ذخیره شد', 'پارامترها با موفقیت ذخیره شدند.');
      dispatch({ type: 'LOADED' });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const {
    bidDuration,
    driverToOriginMaxDistance,
    freightToOriginMaxDistance,
    bidDriverSelectDuration,
    minToleranceOrderPercentage,
    maxToleranceOrderPercentage,
    minToleranceDriversOrderPercentage,
    maxToleranceDriversOrderPercentage,
  } = state.generalParams;

  return (
    <FullCard
      title={props.config.name}
      category="تنظیم پارامترهای کلی نرم افزار"
    >
      {!state.isLoaded ? (
        <Skeleton width="100%" height="400px" variant="rect" animation="wave" />
      ) : (
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignContent="stretch"
          spacing={1}
        >
          <Grid item>
            <TextField
              name="bidDriverSelectDuration"
              value={bidDriverSelectDuration}
              onChange={handleFieldsChange}
              variant="outlined"
              label="مدت زمان انتظار برای تایید مناقصه"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="bidDuration"
              value={bidDuration}
              onChange={handleFieldsChange}
              variant="outlined"
              label="مدت زمان انتظار یک سفارش"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="minToleranceOrderPercentage"
              onChange={handleFieldsChange}
              value={minToleranceOrderPercentage}
              variant="outlined"
              label="حداقل درصد پیشنهاد مناقصه صاحب بار"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="maxToleranceOrderPercentage"
              onChange={handleFieldsChange}
              value={maxToleranceOrderPercentage}
              variant="outlined"
              label="حداکثر درصد پیشنهاد مناقصه صاحب بار"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="minToleranceDriversOrderPercentage"
              onChange={handleFieldsChange}
              value={minToleranceDriversOrderPercentage || 15}
              variant="outlined"
              label="حداقل درصد پیشنهاد مناقصه راننده"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="maxToleranceDriversOrderPercentage"
              onChange={handleFieldsChange}
              value={maxToleranceDriversOrderPercentage || 15}
              variant="outlined"
              label="حداکثر درصد پیشنهاد مناقصه راننده"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="driverToOriginMaxDistance"
              value={driverToOriginMaxDistance}
              onChange={handleFieldsChange}
              variant="outlined"
              label="حداکثر مسافت راننده از محل بار"
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              name="freightToOriginMaxDistance"
              value={freightToOriginMaxDistance}
              onChange={handleFieldsChange}
              variant="outlined"
              label="حداکثر مسافت باربری از محل بار"
              fullWidth
            />
          </Grid>
          <Grid item>
            <Button
              disabled={!state.isLoaded}
              color="secondary"
              variant="contained"
              fullWidth
              onClick={handleSaveForm}
            >
              {!state.isLoaded ? 'صبر کنید ...' : 'ذخیره'}
            </Button>
          </Grid>
        </Grid>
      )}
    </FullCard>
  );
}

export default GeneralParams;
